const getLimits = state => state.limits;

// Value-shaped, not function-shaped: the wizard specs mock `$store.getters` as a plain
// object, so a getter the mock omits must read as `undefined` rather than throw on being
// called. Every consumer guards with `|| null`.
const getCatalogue = state => state.catalogues[state.activeCatalogueKey] || null;
const getCatalogueStatus = state => state.catalogueStatus[state.activeCatalogueKey] || 'idle';
// Every catalogue fetched so far, by key: a partner from the previous target language is
// still named in the learner's task when the target changes.
const getCatalogues = state => state.catalogues;

export default {
  getLimits,
  getCatalogue,
  getCatalogueStatus,
  getCatalogues
};



// WEBPACK FOOTER //
// ./src/store/modules/aiLesson/getters.js